module.exports = __webpack_public_path__ + "img/16.350b386d.jpg";